// src/components/Exaustores/exaustores.js
/**
 * Componente PAI - Orquestrador de Exaustores
 * Responsabilidade: coordenar fluxo de dados entre hook e componentes UI
 */

import React from "react";
import "../../styles/desktop/exaustores.css";
import useExaustor from "../../hooks/useExaustor";
import TimerPadraoBar from "./TimerPadraoBar/TimerPadraoBar";
import ExaustorCard from "./ExaustorCard/ExaustorCard";
import { sortExaustores } from "../../utils/utilsExaustor";

function Exaustores() {
  // Hook com toda a lógica de estado e ações
  const {
    exaustores,
    defaultTimerStr,
    setDefaultTimerStr,
    saving,
    saveMsg,
    handleSaveDefaultTimer,
    toggleExaustor,
    toggleUnidade,
  } = useExaustor();

  // Ordena exaustores para exibição
  const sortedExaustores = sortExaustores(exaustores);

  return (
    <div className="exaustoresCampo">
      {/* Barra de configuração do timer padrão */}
      <TimerPadraoBar
        defaultTimerStr={defaultTimerStr}
        setDefaultTimerStr={setDefaultTimerStr}
        saving={saving}
        saveMsg={saveMsg}
        onSave={handleSaveDefaultTimer}
      />

      {/* Lista de exaustores */}
      <div className="exaustores">
        {sortedExaustores.map((exaustor) => (
          <ExaustorCard
            key={exaustor.id}
            exaustor={exaustor}
            onToggleExaustor={toggleExaustor}
            onToggleUnidade={toggleUnidade}
          />
        ))}
      </div>
    </div>
  );
}

export default Exaustores;